module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-02-jp.3786027397f3a0f5963fcb9dacb6953b.png";